import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { useSelector } from "react-redux";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Draggable from "react-draggable";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Button, Paper } from "@mui/material";
ChartJS.register(ArcElement, Tooltip, Legend);
function PaperComponent(props) {
  return (
    <Draggable
      handle='#draggable-dialog-title'
      cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}
export default function DonutChart() {
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const [labelName, setLabelName] = React.useState("");
  const handleClose = () => {
    setOpen(false);
    setLabelName("");
  };
  const tangibleAsset = useSelector((state) => state.assets);

  const dataToShow = [...tangibleAsset];
  const mode_state = useSelector((state) => state.mode);
  const [mode, setMode] = React.useState(mode_state);
  React.useEffect(() => {
    setMode(mode_state);
  }, [mode_state]);
  const locationData = useSelector((state) => state.locationData);

  let location = [];
  let number = [];

  locationData.map((data) => {
    return location.push(data._id), number.push(data.number);
  });

  const [dataShow, setData] = React.useState([]);
  React.useEffect(() => {
    if (labelName !== "") {
      handleModal();
    }
  }, [labelName]);
  // Example usage:
  function handleModal() {
    const res = dataToShow.filter((asset) => {
      const claimValues = Object.values(asset);

      return claimValues.some(
        (value) =>
          value && value.toString().toLowerCase() === labelName.toLowerCase()
      );
    });

    setData(res);
    handleClickOpen();
  }
  const columns = Object.keys(dataShow[0] || {})
    .filter((key) => key !== "id")
    .map((key) => ({
      field: key,
      headerName: key,
      minWidth: 170,
      align: "left",
    }));
  const data = {
    labels: location,
    datasets: [
      {
        label: "# of Assets",
        data: number,
        backgroundColor: [
          "#16CC62",
          "#344A56",
          "#DDCECD",
          "#1392AB",
          "#8A27A5",
          "#E65D19",
          "#116149",
          "#19C3E6",
          "#E6196E",
          "#E6B219",
        ],
        borderColor: ["#1A1B25"],
        borderWidth: 1,
        datalabels: {
          display: true,
          backgroundColor: "transparent",

          font: {
            size: 14,
            weight: "bold",
          },
        },
      },
    ],
  };
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: "right",
      },
      title: {
        display: true,
        text: "Number of assets per Branches",
      },
    },
    onClick: (event, elements) => {
      if (elements.length > 0) {
        const clickedElementIndex = elements[0].index;
        const labelName = data.labels[clickedElementIndex];
        setLabelName(labelName.toLowerCase());
        // alert(labelName);
      }
    },
  };
  return (
    <div style={{ width: "50%", fontSize: "16px" }}>
      <Doughnut
        height={260}
        options={options}
        data={data}
        style={{
          backgroundColor: `${mode === "dark" ? "#101418" : "#D7DED0"}`,
          borderRadius: "20px",
          cursor: "pointer",
        }}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby='draggable-dialog-title'>
        <DialogTitle style={{ cursor: "move" }} id='draggable-dialog-title'>
          {labelName} Assets
        </DialogTitle>
        <DialogContent>
          <Paper>
            <DataGrid
              columns={columns}
              getRowId={(row) => row.id}
              rows={dataShow}
              slots={{ toolbar: GridToolbar }}
              style={{ height: "50vh" }}
              disableRowSelectionOnClick
            />
          </Paper>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
